import { ExtractPropTypes, PropType } from 'vue'
import { PointerSubtaskDisplayData } from '../types'

export const RespondToTextSubtaskProps = {
  subtask: {
    type: Object as PropType<PointerSubtaskDisplayData>,
    required: true,
  },
} as const

export type RespondToTextSubtaskPropsType = ExtractPropTypes<
  typeof RespondToTextSubtaskProps
>
